import PropTypes from 'prop-types';
import { createContext } from 'react';
import ModesStore from './ModesStore';
import LocationStore from './LocationStore';
import PreferencesStore from './PreferencesStore';
import SessionStore from './SessionStore';
import StatsStore from './StatsStore';
import EventStore from './EventStore';
import LocationContextStore from './LocationContextStore';
import DevicesStore from './DevicesStore';
import LocationStatusStore from './LocationStatusStore';
import GuardStore from './GuardStore';

export class RootStore {
  constructor() {
    this.sessionStore = new SessionStore(this);
    this.locationStore = new LocationStore(this);
    this.locationStatusStore = new LocationStatusStore(this);
    this.locationContextStore = new LocationContextStore(this);
    this.modesStore = new ModesStore(this);
    this.preferencesStore = new PreferencesStore(this);
    this.statsStore = new StatsStore(this);
    this.eventStore = new EventStore(this);
    this.devicesStore = new DevicesStore(this);
    this.guardStore = new GuardStore(this);
  }
}

export const StoresContext = createContext();

export default function RootStoreProvider({ children, value }) {
  const root = new RootStore();

  return <StoresContext.Provider value={value ?? root}>{children}</StoresContext.Provider>;
}

RootStoreProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  value: PropTypes.instanceOf(RootStore),
};
